// extracted by mini-css-extract-plugin
module.exports = {"ErrorPlaceholder":"ErrorPlaceholder_ErrorPlaceholder__19OZJ"};